import useStyles from "./Footer.styles";

type SocialLinkType = Partial<{
  url: string;
  icon: any;
  title: string,
}>;
type propsType = {
  email: string;
  name: string;
  phoneNumber: string;
  socialLink?: SocialLinkType[];
};
function Footer({ email, name, phoneNumber, socialLink = [] }: propsType) {
  const classes = useStyles();

  return (
    <div className={classes.footerBg}>
      <div className={classes.footerContent}>
        <button onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' })}}>back to top</button>
        <div className={classes.socialIcon}>
          {socialLink.map((link: SocialLinkType, index) => (
            <a
              key={index}
              href={link.url}
              rel="noreferrer"
              target="_blank"
              className={classes.footerIcon}
            >
              <link.icon />
            </a>
          ))}
        </div>
        <div className={classes.contact}>
          <span className={classes.contactMail}>{email}</span>
          <span className={classes.contactNumber}>{phoneNumber}</span>
        </div>

        <div className={classes.copyRight}>&copy;{name} 2020</div>
      </div>
    </div>
  );
}

export default Footer;
